import { FC, useEffect } from 'react';
import { PaddingBox } from '../../components/PaddingBox';
import {
	ListLayout,
	ListLayoutBar,
	ListLayoutBarItem,
	ListLayoutBarLeft,
	ListLayoutTitle,
} from '../list/components/ListLayout';
import { useTranslationAPI } from '../translations';
import { backofficeModuleCodes } from '../../data/translations/backofficeModuleCodes';
import { setDocumentTitle } from '../page/utils';
import { BackofficeWidgetPlaceholder } from './components/BackofficeWidget/BackofficeWidgetPlaceholder';

export const BackofficeActionPagePlaceholder: FC = () => {
	const { translate } = useTranslationAPI();

	useEffect(() => {
		setDocumentTitle(translate(backofficeModuleCodes.backofficeProcess));
	}, [translate]);

	return (
		<ListLayout custom>
			<PaddingBox
				hrSmall
				vrMedium
			>
				<ListLayoutBar>
					<ListLayoutBarLeft>
						<ListLayoutBarItem>
							<ListLayoutTitle>{translate(backofficeModuleCodes.actionPage)}</ListLayoutTitle>
						</ListLayoutBarItem>
					</ListLayoutBarLeft>
				</ListLayoutBar>
				<div
					style={{
						margin: '0 auto',
						maxWidth: '1120px',
						position: 'relative',
						display: 'flex',
						flexWrap: 'wrap',
					}}
				>
					<BackofficeWidgetPlaceholder />
					<BackofficeWidgetPlaceholder />
					<BackofficeWidgetPlaceholder />
					<BackofficeWidgetPlaceholder />
					<BackofficeWidgetPlaceholder />
				</div>
			</PaddingBox>
		</ListLayout>
	);
};
